//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    color: var(--light-gray-5);
    list-style: none;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;